import React, { useContext, useEffect, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { ConfigContext } from "../Context/ConfigContext";
import axios from "axios";
import CryptoJS from "crypto-js";
import LazyImage from "../Components/LazyImage";

const HeaderTemp = () => {
  const { apiURL, employee_id, apiHeaderJSON,setPermissions,inductionStatus } = useContext(ConfigContext);
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [employeeData, setEmployeeData] = useState({});

  const handleLogout = () => {
    localStorage.removeItem("token_emp");
    localStorage.removeItem("company_id_emp");
    localStorage.removeItem("employee_id_emp");
    localStorage.removeItem("employee_code_emp");
    localStorage.removeItem("induction_status");
    localStorage.setItem("reset_emp",true);
    window.location.href = '/'
  };
  
  const getList = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}User/GetEmployeeModuleHierarchy`, {
        params: {},
        headers,
      })
      .then((response) => {
        let data = response.data;
        // console.log(data);
        if (response.data.success === true) {
          setModules(data?.result);
          setPermissions(data?.result);
        } else {
          console.error("Error fetching list");
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  };

  useEffect(() => {
    getList();
  }, []);

  const getEmployeeData = () => {
    let options = {
      url: `${apiURL}Home/GetProfile?employee_id=${employee_id}`,
      method: "GET",
      headers: apiHeaderJSON,
    };
    axios(options)
      .then((response) => {
        let data = response?.data;
        if (response.data.success === true) {
          // console.log("GetProfile ~ res", data?.data?.employee);
        //   localStorage.setItem("company_code",data?.data[0]?.company_code);
        //   setCompanyName(data?.data[0]?.company_user_name);
          setEmployeeData(data?.data?.employee);
        //   setLogoData(data?.logo_data[0]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    getEmployeeData();
  }, []);
  // console.log("REACT_APP_SECRET_KEY",process.env.REACT_APP_SECRET_KEY);

  const handleNavigate = (path,data) => {
    setIsMenuOpen(false);
    // console.log("id",data);
    const queryData = data;
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(queryData),process.env.REACT_APP_SECRET_KEY).toString();
    const encodedQuery = encodeURIComponent(encryptedData);
    // console.log("encodedQuery",encodedQuery);
    // console.log("abs=${encodedQuery}",`${path}?abs=${encodedQuery}`);
    if(data){
      navigate(`${path}?abs=${encodedQuery}`);
    }
    else{
      navigate(`${path}`);
    }
    
  };

  const renderModules = (modules) => {
    return modules.map((module, index) => (
      <li key={index} className="nav-item">
        <span
          onClick={()=> module?.path && handleNavigate(module?.path,module?.header_id)}
          style={{ padding: "0.5rem 1rem", color: "gray" }}
          className="nav-link menu-link"
          data-bs-toggle={module.sub_module ? "collapse" : undefined}
          role="button"
          aria-expanded="false"
          aria-controls={`sidebar-${index}`}
          activeClassName="active-link" 
        >
          <span
            // style={{ fontSize: "0.8rem" }}
            className="link-text"
            data-key="t-apps"
          >
            {module.name}
          </span>
        </span>

        {/* Check if the module has sub-modules */}
        {module.sub_module && module.sub_module?.length > 0 && (
          <div className="collapse menu-dropdown" id={`sidebar-${index}`}>
            <ul
            //   style={{ fontSize: "0.8rem", marginRight: "0.2rem"}}
              className="nav nav-md flex-column"
            >
              {renderModules(module.sub_module)}
            </ul>
          </div>
        )}
      </li>
    ));
  };
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // console.log("isMenuOpen",isMenuOpen);
  const toggleMenu = () => {console.log(isMenuOpen); setIsMenuOpen(!isMenuOpen);}
  const [activeHeaderId, setActiveHeaderId] = useState(null);

  const [openStates, setOpenStates] = useState({});
  const renderMobileModules = (modules, parentIndex = '', openStates, setOpenStates, level = 0) => {
    return modules.map((module, index) => {
      const currentIndex = `${parentIndex}${index}`;
      console.log("name", module?.name);
      console.log("module.sub_module length", module.sub_module);
      const hasChildren = module.sub_module && module.sub_module.length > 0;
      const isOpen = openStates[currentIndex] || false;
  
      const toggleCollapse = () => {
        setOpenStates((prev) => ({
          ...prev,
          [currentIndex]: !prev[currentIndex]
        }));
      };
  
      return (
        <li key={currentIndex} className="nav-item">
          <div
            className={`nav-link custom-menu-link ${hasChildren ? "has-children" : ""} ${
              module.path && activeHeaderId === module.header_id ? "active-module" : ""
            }`}
            onClick={() => {
              console.log("hasChildren",hasChildren);
              if (hasChildren) {
                toggleCollapse();
              }
              if (module.path) {
                setActiveHeaderId(module.header_id);
                handleNavigate(module.path, module.header_id);
              }
            }}
          >
            {/* <i className={`ri-arrow-right-s-line`} /> */}
            {/* <span className={`arrow ${isOpen ? "rotate" : ""}`}>
                <i className={`ri-arrow-right-s-line`} />
              </span> */}
            <span>{module.name}</span>
            {hasChildren && (
              <span className={`arrow ${isOpen ? "rotate" : ""}`}>&#9656;</span>
              // <span style={{ height: "0.5rem", width: "0.5rem" }} className={`arrow ${isOpen ? "rotate" : ""}`}>
              //   <i className={`ri-arrow-right-s-line`} />
              // </span>
            )}
          </div>
  
          {hasChildren && (
            <div className={`custom-collapse level-${level} ${isOpen ? "open" : ""}`}>
              <ul className="nav nav-sm flex-column">
                {renderMobileModules(module.sub_module, `${currentIndex}-`, openStates, setOpenStates,level + 1)}
              </ul>
            </div>
          )}
        </li>
      );
    });
  };
  
  
  
  return (
    <>
      <header id="page-topbar">
        <div className={`app-menu-mob navbar-menu-mob ${isMenuOpen ? 'menu-open' : ''} mt-0 ps-0`} style={{ paddingRight: "5rem" }}>
          <div className="h-100 d-flex flex-column bg-white">
            {/* Fixed top section */}
            <div className="pe-3 py-2 sticky-top bg-white z-2 border-bottom">
              <button type="button" style={{ height: "2rem" }} className="btn btn-sm fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" onClick={toggleMenu} id="topnav-hamburger-icon">
                <i className="ri-arrow-left-line fs-1" />
              </button>
              <li className="menu-title mt-3"><span data-key="t-menu">Menu</span></li>
            </div>
            {/* Scrollable list */}
            <div id="scrollbar" data-simplebar className="flex-grow-1 overflow-auto">
              <ul className="navbar-nav d-flex flex-column" id="navbar-nav">
                {renderMobileModules(modules, '', openStates, setOpenStates)}
              </ul>
            </div>
          </div>
          <div className="sidebar-background" onClick={toggleMenu} />
        </div>
        <div className="layout-width">
          <div style={{ height: "54px"}} className="navbar-header">
            <div className="d-flex align-items-center">
              <button type="button" className="btn btn-sm px-0 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" onClick={toggleMenu} id="topnav-hamburger-icon">
                <span className="hamburger-icon">
                  <span />
                  <span />
                  <span />
                </span>
              </button>
              
              <div className="navbar-brand-box horizontal-logo p-2">
                {/* Dark Logo */}
                <NavLink to="/" className="logo-dark d-block d-lg-block">
                  <div className="d-flex align-items-center gap-1">
                    <div className="logo">
                      <LazyImage src={`${process.env.REACT_APP_BASE_URL}assets/abstart-logo.png`} style={{ width: "100%", maxHeight: "3rem" }} alt="logo" className="logo-img"/>
                    </div>
                    <div className="logo">
                      <LazyImage src={employeeData?.company_logo_url} style={{ width: "100%", maxHeight: "3rem" }} alt="Company_logo" className="logo-img"/>
                    </div>
                  </div>
                </NavLink>

                {/* Light Logo - shown on small screens */}
                {/* <NavLink to="/" className="logo logo-light d-md-flex">
                  <span className="logo-sm">
                    <LazyImage src={`${process.env.REACT_APP_BASE_URL}assets/abstart-logo.png`} style={{ width: "6rem", maxHeight: "3rem" }} alt="logo" className="logo-img"/>
                  </span>
                  <span className="logo-sm">
                    <LazyImage src={employeeData?.company_logo_url} style={{ width: "6rem", maxHeight: "3rem" }} alt="Company_logo" className="logo-img"/>
                  </span>
                </NavLink> */}
              </div>
              <h6 className="d-none d-md-inline-block ms-1 fw-medium user-name-text text-truncate mb-0 fw-semibold"
              style={{ maxWidth: "30rem", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis",}}>
                {employeeData?.company_name}
              </h6>
            </div>
            <div className="d-flex align-items-center">
              <h6
                className="d-none d-sm-inline-block ms-1 fw-medium user-name-text text-truncate mb-0 fw-semibold"
                style={{ maxWidth: "20rem", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", }}>
                {employeeData?.employee_name}
              </h6>
              <div className="dropdown ms-sm-3 header-item h-auto topbar-user rounded-3">
                  <button type="button" className="btn p-1" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span className="d-flex align-items-center">
                      <LazyImage src={`${employeeData?.employee_profile_url || "assets/profile-pic.png"}`} 
                      alt="Company_logo" className="rounded-circle header-profile-user" />
                    </span>
                  </button>
                  <div className="dropdown-menu">
                    {/* item*/}
                    <h6 className="dropdown-header">
                    <span className=" d-xl-inline-block ms-1 fw-bold fw-medium user-name-text"
                        style={{ maxWidth: "500px", textWrap: "wrap" }}>
                        {employeeData?.employee_code}
                      </span><br/>
                      <div className="dropdown-divider" />
                      <span className=" d-xl-inline-block ms-1 fw-medium user-name-text"
                        style={{ maxWidth: "500px", textWrap: "wrap" }}>
                        {employeeData?.employee_name}
                      </span>
                      
                    </h6>
                    <div className="dropdown-divider" />
                    <button style={{ width:"90%"}} className="dropdown-item m-auto border border-danger rounded-3" onClick={handleLogout}>
                      <i className="mdi mdi-logout text-danger fs-16 align-middle me-1" /> 
                      <span className="align-middle text-danger" data-key="t-logout">Logout</span>
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {inductionStatus === "0" ? null : 
        (<div style={{ marginTop: "54px"}} className="app-menu navbar-menu">
          <div style={{ maxWidth: "90%" }} className=" m-auto">
            <div id="two-column-menu"></div>
            <ul
              className="d-flex gap-3 align-items-center flex-wrap navbar-nav flex-row"
              id="navbar-nav"
            >
              <li className="menu-title">
                <span data-key="t-menu">Menu</span>
              </li>
              {renderModules(modules)}
            </ul>
          </div>
        </div>)
      }
    </>
  );
};

export default HeaderTemp;
